import { BlockEmbed } from 'quill/blots/block';
import { Parchment } from 'quill/core';
import Diff from './Diff';
import UserSequence from './UserSequence';
import VersionChange from './VersionChange';

class HorizontalRule extends BlockEmbed {
  static create(value: unknown) {
    const node = super.create(value) as HTMLHRElement;
    // @ts-expect-error Fix next time editing the file
    node.setAttribute('contenteditable', false);
    return node;
  }

  format(name: string, value: unknown) {
    if (
      [Diff.attrName, VersionChange.attrName, UserSequence.attrName].includes(
        name,
      )
    ) {
      const attributor = this.scroll.query(name, Parchment.Scope.ATTRIBUTE);
      if (attributor) {
        // @ts-expect-error
        this.attributes.attribute(attributor, value);
      }
    } else {
      super.format(name, value);
    }
  }

  formats() {
    return this.attributes.values();
  }
}
HorizontalRule.blotName = 'hr';
HorizontalRule.tagName = 'hr';

export default HorizontalRule;
